// extracted by mini-css-extract-plugin
export default {"tutorialModal":"tutorialModal__ttuJRO","controls":"controls__mSN7mA","primaryButton":"primaryButton__Qa8TfW","text":"text__W3mR4a","image":"image__rBO5n9"};